import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import { StateService } from '@app/service/state/state.service';

import {
  KalpAnswersNO,
  KalpInfoReason,
  LeqService,
} from '@app/service/leq/leq.service';
import { NoRoute } from '@assets/val/route-constants';
import { NoUserService } from '@app/service/no-user-service/no-user.service';

@Component({
  selector: 'no-loan-eligibility-questionnaire-review',
  templateUrl: './no-loan-eligibility-questionnaire-review.component.html',
  styleUrls: [
    '../../page-shared.css',
    './no-loan-eligibility-questionnaire-review.component.scss',
  ],
})
export class NoLeqReviewComponent extends RouteComponent implements OnInit {
  loading: boolean = true;
  error: boolean = false;
  navigationInProgress: boolean;

  kalpAnswers: KalpAnswersNO;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private noUserService: NoUserService,
    private leqService: LeqService
  ) {
    super(router, route, stateService, headerService);
  }

  async ngOnInit(): Promise<void> {
    await this.setup();
  }

  async setup(): Promise<void> {
    this.kalpAnswers = this.leqService.getKalpAnswersNO();

    if (!this.kalpAnswers) {
      try {
        this.noUserService
          .getKalpInfo(KalpInfoReason.REJECTED)
          .subscribe((resp) => {
            if (resp) {
              this.kalpAnswers = resp;
              this.leqService.setKalpAnswersNO(resp);
            } else {
              this.error = true;
            }
          });
      } catch (err) {
        this.error = true;
        this.handleError(err);
      }
    }

    this.loading = false;
  }

  async handleCancellation(): Promise<void> {
    this.navigationInProgress = true;
    this.router.navigate([NoRoute.HOME], {
      queryParamsHandling: 'merge',
    });
    this.navigationInProgress = false;
  }

  async handleCtaClickReview(): Promise<void> {
    this.loading = true;

    try {
      await this.noUserService
        .postKalpAnswers(this.kalpAnswers)
        .then(() => this.navigate());
    } catch (err) {
      this.error = true;
      this.handleError(err);
    }
  }

  handleUpdateClick(): void {
    this.navigate();
  }
}
